import React from "react";
import 'mapbox-gl/dist/mapbox-gl.css';
import './App.css';
import MapboxMap from "./MapboxMap/MapboxMap";

const App = () => {
	return (
		<div className="App">
			<MapboxMap />
		</div>
	);
}

export default App;
